export const AdsStudioAppNameODataHeader = {
  key: 'x-ms-applicationname',
  value: 'bingadsweb-assetlibrary',
};

